import React from "react"
import ReactDOM from "react-dom"
import { DesignStudioSlice } from "../../../_redux/admin/designStudio/DesignStudioSlice"
import mapboxgl from "!mapbox-gl"
import PopupStickOnHoverManageInfrastructure from "./PopupStickOnHoverManageInfrastructure"
import "./AnchorsPositioning.css"
import moment from "moment"
import { RenderUuidDiv } from "../_partials/RenderUuidDiv"
import RenderActiveAnchorPopup from "./_partials/RenderActiveAnchorPopup"

// Progress button #buttonToProgress2 and 3
export function startButtonProgress(button, progressClassName, textClassName) {
	if (button && progressClassName && textClassName) {
		// if (button.id === "buttonToProgress_createPoi") {
		const textElement = button.querySelector(`.${textClassName}`)
		// Simulate counting to 99%
		let percent = 0
		for (var j = 0; j < 100; j++) {
			percent = j
			button.querySelector(`.${progressClassName}`).style.width = `${percent}%`

			if (percent >= 0) {
				textElement.textContent = button.dataset.progressText
			}
			if (percent >= 100) {
				textElement.textContent = button.dataset.completeText
			}
		}
		// }
	}
}

// Finish progress button #buttonToProgress2 and 3
export function finishButtonProgress(button, progressClassName, textClassName, actionFinished) {
	if (button && progressClassName && textClassName && actionFinished === 100) {
		// if (button.id === "buttonToProgress_createPoi") {
		const textElement = button.querySelector(`.${textClassName}`)
		// Simulate counting to 100%
		let percent = actionFinished
		button.querySelector(`.${progressClassName}`).style.width = `${percent}%`

		if (percent >= 0) {
			textElement.textContent = button.dataset.progressText
		}
		if (percent >= 100) {
			textElement.textContent = button.dataset.completeText
		}
		// }
	}
}

function TimeInfo(props) {
	const { anchor, checkIn, lastSeen } = props

	return (
		<div className="d-flex" style={{ padding: "0px 10px 8px 10px" }}>
			<div
				className="flex-fill mr-2"
				style={{
					background: "#FFFFFF",
					borderRadius: "4px"
				}}
			>
				<div
					style={{
						margin: "3px",
						textAlign: "center",
						fontWeight: "300",
						lineHeight: "160%",
						fontSize: "10px",
						color: "#4A4A68"
					}}
				>
					Status
				</div>
				<hr className="m-0" />
				<div
					style={{
						margin: "3px",
						textAlign: "center",
						fontWeight: "600",
						lineHeight: "160%",
						fontSize: "11px",
						color: "#4A4A68"
					}}
				>
					{anchor?.status || ""}
				</div>
			</div>
			<div
				className="flex-fill"
				style={{
					background: "#FFFFFF",
					borderRadius: "4px"
				}}
			>
				<div
					style={{
						margin: "3px",
						textAlign: "center",
						fontWeight: "300",
						lineHeight: "160%",
						fontSize: "10px",
						color: "#4A4A68"
					}}
				>
					First Seen
				</div>
				<hr className="m-0" />
				<div
					style={{
						margin: "3px",
						textAlign: "center",
						fontWeight: "600",
						lineHeight: "160%",
						fontSize: "11px",
						color: "#4A4A68"
					}}
				>
					{checkIn}
				</div>
			</div>
			<div
				className="flex-fill ml-2"
				style={{
					background: "#FFFFFF",
					borderRadius: "4px"
				}}
			>
				<div
					style={{
						margin: "3px",
						textAlign: "center",
						fontWeight: "300",
						lineHeight: "160%",
						fontSize: "10px",
						color: "#4A4A68"
					}}
				>
					Last Seen
				</div>
				<hr className="m-0" />
				<div
					style={{
						margin: "3px",
						textAlign: "center",
						fontWeight: "600",
						lineHeight: "160%",
						fontSize: "11px",
						color: "#4A4A68"
					}}
				>
					{lastSeen}
				</div>
			</div>
		</div>
	)
}

function DescriptionInfo(props) {
	const { anchor } = props

	return (
		<div className="d-flex" style={{ padding: "0px 10px 10px 10px" }}>
			<div
				className="flex-fill"
				style={{
					background: "#FFFFFF",
					borderRadius: "4px",
					overflowY: "auto", // Enable vertical scrolling
					maxHeight: "75px" // Set the maximum height to display 2 lines of text
				}}
			>
				<div
					style={{
						margin: "3px",
						textAlign: "center",
						fontWeight: "300",
						lineHeight: "160%",
						fontSize: "10px",
						color: "#4A4A68"
					}}
				>
					Description
				</div>
				<hr className="m-0" />
				<div
					style={{
						margin: "3px",
						textAlign: "center",
						fontWeight: "600",
						lineHeight: "160%",
						fontSize: "11px",
						color: "#4A4A68"
					}}
				>
					{anchor.description}
				</div>
			</div>
		</div>
	)
}

export async function addNodesToMap(params) {
	const {
		map,
		selectedSite,
		selectedCustomer,
		user,
		currentFloorPlan,
		nodesData,
		markers,
		setMarkers,
		showOnline,
		showRemoved,
		showLost,
		showAnchorsUid,
		setShowActiveModal,
		setActiveNodeToUpdate,
		setShowBigImageModalActive,
		setSelectedBigImageActive,
		setSelectedImageIndexActive,
		removePopupFunction,
		setActiveNodes,
		defaultSrc,
		dragMarker,
		dragSvg,
		nodeType = "anchor",
		poiActions,
		firebase,
		dispatch
	} = params

	if (!map || !selectedSite || !currentFloorPlan) return

	// Remove anchor markers
	markers && markers.forEach(marker => marker.remove())
	setMarkers()

	let dragClass =
		nodeType === "sensor" ? "iconImageSensorsPositionDrag" : "iconImageAnchorsPositionDrag"
	let notDragClass =
		nodeType === "sensor" ? "iconImageSensorsPosition" : "iconImageAnchorsPosition"

	var _nodes = nodesData
		? nodesData
				.filter(
					val =>
						val?.floorPlanId &&
						val?.floorPlanId === currentFloorPlan.id &&
						val?.status &&
						val?.status != "assigned" &&
						val?.status != "created" &&
						val?.status != "unassigned"
				)
				.filter(val => {
					if (!showOnline && !showRemoved && !showLost) {
						return false // Exclude all statuses if all flags are false
					} else if (!showOnline && !showRemoved) {
						return val.status !== "online" && val.status !== "removed"
					} else if (!showOnline && !showLost) {
						return val.status !== "online" && val.status !== "lost"
					} else if (!showRemoved && !showLost) {
						return val.status !== "removed" && val.status !== "lost"
					} else if (!showOnline) {
						return val.status !== "online"
					} else if (!showRemoved) {
						return val.status !== "removed"
					} else if (!showLost) {
						return val.status !== "lost"
					}
					return true // Include all statuses by default if no flags are false
				})
		: []

	// Add marker for each active anchor
	const newMarkers =
		_nodes &&
		_nodes
			.map(val => {
				// Check if all the needed data is present
				if (!val.gpsData) return null

				// check if is a firestore timestamp or string
				const parsedTimestampFirstSeen =
					val && val.firstSeen && val.firstSeen.toDate
						? moment(val.firstSeen.toDate()).format("hh:mm A")
						: null

				const parsedTimestampLastSeen =
					val && val.lastSeen && val.lastSeen.toDate
						? moment(val.lastSeen.toDate()).format("hh:mm A")
						: null

				const checkIn =
					val && val?.firstSeen && parsedTimestampFirstSeen
						? parsedTimestampFirstSeen
						: val && val?.firstSeen
						? moment(val.firstSeen).format("hh:mm A")
						: "--:--"

				const lastSeen =
					val && val?.lastSeen && parsedTimestampLastSeen
						? parsedTimestampLastSeen
						: val && val?.lastSeen
						? moment(val.lastSeen).format("hh:mm A")
						: "--:--"

				const div = document.createElement("div")
				div.className = "connectorsMarkerDashboard"
				div.style.cursor = !dragMarker ? "pointer" : "grab"
				div.setAttribute("id", val.id)

				const popupStickNew = (
					<PopupStickOnHoverManageInfrastructure
						component={
							!dragMarker && (
								<RenderActiveAnchorPopup
									val={val}
									setSelectedBigImageActive={setSelectedBigImageActive}
									setSelectedImageIndexActive={setSelectedImageIndexActive}
									setShowBigImageModalActive={setShowBigImageModalActive}
									setShowActiveModal={setShowActiveModal}
									setActiveNodeToUpdate={setActiveNodeToUpdate}
									checkIn={checkIn}
									lastSeen={lastSeen}
									removePopupFunction={removePopupFunction}
									TimeInfo={TimeInfo}
									DescriptionInfo={DescriptionInfo}
									nodeType={nodeType}
								/>
							)
						}
						placement="top"
						onMouseEnter={() => {}}
						delay={500}
						className={
							nodeType === "sensor"
								? "popup_stick_active_sensors"
								: "popup_stick_active_anchors"
						}
					>
						<div
							className="connectorsMarkerDashboard"
							style={{ position: "relative", cursor: !dragMarker ? "pointer" : "grab" }}
							id={val.id}
						>
							{showAnchorsUid && RenderUuidDiv({ uuid: val.id })}
							<div
								className="popupLineRoutes"
								style={{
									backgroundColor:
										val.status === "online"
											? "#2649AA"
											: val.status === "lost"
											? "#a43912"
											: val.status === "removed"
											? "#ff0000"
											: "#3B7E38",
									borderRadius: "50%",
									width: "34px",
									height: "34px",
									outline: "2px solid #ffffff",
									position: "relative"
								}}
							>
								<img
									src={dragMarker ? dragSvg : defaultSrc}
									alt="anchor icon"
									className={dragMarker ? dragClass : notDragClass}
								/>
							</div>
						</div>
					</PopupStickOnHoverManageInfrastructure>
				)

				ReactDOM.render(popupStickNew, div)

				const marker = new mapboxgl.Marker(div, {
					draggable: dragMarker
				})

				marker.setLngLat([val.gpsData.longitude, val.gpsData.latitude]).addTo(map)

				//drag anchor logic - only for approved anchors - call new api
				val?.gpsData &&
					marker.on("drag", () => {
						const popupElement = document.getElementById("popover")

						if (popupElement) {
							popupElement.style.display = "none"
						}
					})

				val?.gpsData &&
					marker.on("dragend", val => {
						const lngLat = val.target.getLngLat()
						const markerId = parseInt(val.target.getElement().getAttribute("id"))

						// Update POIs state
						let newPointsOfInterest = [..._nodes]

						newPointsOfInterest = newPointsOfInterest.map(poi => {
							if (poi.uuid?.toString() === markerId?.toString()) {
								return {
									...poi,
									floorPlanId: currentFloorPlan.id,
									gpsData: new firebase.firestore.GeoPoint(lngLat.lat, lngLat.lng),
									edit: true
								}
							}
							return poi
						})

						setActiveNodes(newPointsOfInterest)

						dispatch(
							poiActions.updateApprovedNodes({
								siteId: selectedSite.id,
								node: {
									id: markerId,
									latitude: lngLat.lat,
									longitude: lngLat.lng
								},
								callersUserId: user.id,
								customerId: selectedCustomer.id
							})
						)
					})

				return marker
			})
			.filter(val => val)

	setMarkers(newMarkers)
	return
}
